import styled from '@emotion/styled';
import { Flex } from '@pairy/pds-react';
import { theme } from '@pairy/styles';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

export const PageNavigationButton = styled(Flex)`
  position: fixed;

  z-index: ${VIEWER_Z_INDEX.desktopLayer};
  bottom: 32px;

  left: 50%;
  width: auto;
  border: 1px solid ${theme.colors.zinc_500};

  backdrop-filter: blur(8px);
  background: rgb(255 255 255 / 50%);

  border-radius: 9999px;
  transform: translateX(-50%);

  transition: opacity 0.15s ease-in-out;

  &.disabled {
    cursor: initial;
    opacity: 0.5;
  }
`;
